
      export default {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 109.5 124.5"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M95.9 24.2c-.1-.6-.6-1-1.1-1-.5 0-10-.7-10-.7s-6.6-6.6-7.4-7.3c-.7-.7-2.2-.5-2.7-.3-.1 0-1.5.4-3.7 1.1-2.2-6.4-6.1-12.3-13-12.3h-.6C55.4 1.1 53 0 50.9 0 34.8 0 27.1 20.1 24.7 30.3c-6.2 1.9-10.7 3.3-11.2 3.5-3.5 1.1-3.6 1.2-4 4.5-.4 2.4-9.5 72.9-9.5 72.9l71 13.3 38.5-8.3S96 24.9 95.9 24.2zm-28.9-7c-1.8.6-3.8 1.2-6 1.9v-1.3c0-4-.6-7.2-1.4-9.7 3.6.4 5.9 4.4 7.4 9.1zM55.2 8.8c1 2.5 1.6 6 1.6 10.8v.7c-3.9 1.2-8.2 2.5-12.4 3.8 2.4-9.1 6.9-13.6 10.8-15.3zm-4.8-4.5c.7 0 1.4.2 2.1.7-5.1 2.4-10.7 8.5-13 20.7-3.4 1.1-6.7 2.1-9.8 3 2.7-9.3 9.2-24.4 20.7-24.4z","fill":"#95bf47"}}),_c('path',{attrs:{"d":"M94.8 23.2c-.5 0-10-.7-10-.7s-6.6-6.6-7.4-7.3c-.3-.3-.6-.4-1-.5L71 124.5l38.5-8.3S96 24.9 95.9 24.3c-.1-.7-.7-1-1.1-1.1z","fill":"#5e8e3e"}}),_c('path',{attrs:{"d":"M57.9 44.5l-4.7 14.1S49 56.4 44 56.4c-7.5 0-7.8 4.7-7.8 5.9 0 6.4 16.8 8.9 16.8 24 0 11.9-7.5 19.5-17.7 19.5-12.2 0-18.4-7.6-18.4-7.6l3.3-10.8s6.4 5.5 11.8 5.5c3.5 0 5-2.8 5-4.8 0-8.4-13.8-8.8-13.8-22.6 0-11.6 8.3-22.9 25.2-22.9 6.3 0 9.5 1.9 9.5 1.9z","fill":"#fff"}})])
          )
        }
      }
    